import { matchRoute } from '@townsquare/router/primitives/match-route';
import { useRouter } from '@townsquare/router/useRouter';
import { teamsSettingsRoute } from '@townsquare/routes/teams-settings-view';

export const useIsSettingsRoute = (): boolean => {
	const [routerStore] = useRouter();
	return Boolean(matchRoute([teamsSettingsRoute], routerStore.location.pathname, undefined));
};
